// One catalog for the whole site; the server reads the same file for the text it renders itself (see Site.t).
import messages from './messages.json'

export const supportedLocales = ['en', 'pt-br'] as const

export type Locale = (typeof supportedLocales)[number]

export const defaultLocale: Locale = 'en'

export type MessageKey = keyof (typeof messages)['en']

/** The language switcher's cookie, which the server reads to pick the home page's language. */
export const LOCALE_COOKIE = 'ri_lang'

export function isLocale(value: string | null | undefined): value is Locale {
  return !!value && (supportedLocales as readonly string[]).includes(value)
}

export function t(locale: Locale, key: MessageKey): string {
  return messages[locale][key] ?? messages[defaultLocale][key]
}
